import { useState, useEffect } from 'react'
import './AngledHero.css'

const API = process.env.REACT_APP_API_URL || ""

const ROW_KEYS = {
    top: ["ft_row1_1", "ft_row1_2", "ft_row1_3", "ft_row1_4", "ft_row1_5"],
    center: ["ft_row2_1", "ft_row2_2", "ft_row2_3", "ft_row2_4", "ft_row2_5"],
    bottom: ["ft_row3_1", "ft_row3_2", "ft_row3_3", "ft_row3_4", "ft_row3_5"],
}

// Pure CSS @keyframes — GPU compositor only, zero JS animation
function Row({ keys, media, direction, animDelay }) {
    const tiles = [...keys, ...keys, ...keys, ...keys]
    return (
        <div className="ah-row">
            <div
                className={`ah-track ah-track-${direction}`}
                style={{ animationDelay: `${animDelay}s` }}
            >
                {tiles.map((k, i) => (
                    <div key={i} className="ah-card">
                        {media[k]
                            ? <img src={media[k]} alt="" loading="lazy" decoding="async" className="ah-img" />
                            : <div className="ah-ph" />
                        }
                        <div className="ah-overlay" />
                        <div className="ah-shine" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default function AngledHero() {
    const [media, setMedia] = useState({})
    const [ready, setReady] = useState(false)

    useEffect(() => {
        fetch(`${API}/api/media/flytutor`)
            .then(r => r.json())
            .then(d => setMedia(d || {}))
            .catch(() => { })
        const t = setTimeout(() => setReady(true), 100)
        return () => clearTimeout(t)
    }, [])

    return (
        <section className={`ah ${ready ? 'ah-ready' : ''}`}>

            {/* Background */}
            <div className="ah-bg" />
            <div className="ah-grain" />

            {/* Ambient blobs — pure CSS */}
            <div className="ah-blob ah-blob-1" />
            <div className="ah-blob ah-blob-2" />
            <div className="ah-blob ah-blob-3" />

            {/* Particles — pure CSS */}
            <div aria-hidden="true" className="ah-particles">
                {[...Array(12)].map((_, i) => <span key={i} className={`ah-p ah-p${i}`} />)}
            </div>

            {/* Diagonal scrolling rows */}
            <div className="ah-rows">
                <Row keys={ROW_KEYS.top} media={media} direction="ltr" animDelay={0} />
                <Row keys={ROW_KEYS.center} media={media} direction="rtl" animDelay={-6} />
                <Row keys={ROW_KEYS.bottom} media={media} direction="ltr" animDelay={-12} />
            </div>

            {/* Vignette */}
            <div className="ah-mask" />

            {/* Flytutor hero content */}
            <div className="ah-fg">
                <div className="ah-badge">
                    <span className="ah-badge-dot" />
                    DGCA AUTHORIZED RPTO · INDIA
                </div>
                <h1 className="ah-h1">
                    <span className="ah-word">TRAIN</span>
                    <span className="ah-word">CERTIFY.</span>
                    <span className="ah-word ah-word-accent">FLY.</span>
                </h1>
                <p className="ah-sub">
                    Start your drone career with expert training and government-approved certification.
                </p>
                <div className="ah-actions">
                    <a href="https://flytutor.in" target="_blank" rel="noreferrer" className="ah-btn">
                        Visit Flytutor.in ↗
                    </a>
                    <a href="#courses" className="ah-btn-ghost">Explore Courses</a>
                </div>
            </div>

            {/* Scroll cue */}
            <div className="ah-scroll-cue" aria-hidden="true">
                <div className="ah-scroll-mouse">
                    <div className="ah-scroll-dot" />
                </div>
                <span>SCROLL</span>
            </div>

        </section>
    )
}